import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DASHBOARD_STAT } from "./apiRoutes";

interface UseGetExpenseChartDataProps {
  year: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getExpenseChartData = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${DASHBOARD_STAT(communityId)}/expense-income/performance?year=${year}`
  );

const useGetExpenseIncomePerformance = ({
  year,
  communityId,
  queryParams,
}: UseGetExpenseChartDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["expense-income-performance", communityId, year],
    queryFn: () => getExpenseChartData(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: queryParams?.enabled,
  });
};

export default useGetExpenseIncomePerformance;
